/**
 * @author Kajabi, LLC <info@kajabi.com>
 * @license MIT
 */
import { Entity } from "@backstage/catalog-model";

export const DEFAULT_HONEYBADGER_PROJECT_KEY = "43379";
export const HONEYBADGER_PROJECT_KEY_ANNOTATION = "honeybadger.io/project-key";
export const HONEYBADGER_QUERY_ANNOTATION = "honeybadger.io/query";
export const HONEYBADGER_TEAM_PROJECT_KEY_ANNOTATION =
  "honeybadger.io/project-keys";

export const useProjectEntity = (entity: Entity) => {
  if (entity.kind !== "Group") {
    const key =
      (entity.metadata?.annotations?.[
        HONEYBADGER_PROJECT_KEY_ANNOTATION
      ] as string) || DEFAULT_HONEYBADGER_PROJECT_KEY;

    return {
      projectKeys: [key],
      queries: {
        [key]: entity.metadata?.annotations?.[
          HONEYBADGER_QUERY_ANNOTATION
        ] as string,
      },
    };
  }

  const keysAnnotation = entity.metadata?.annotations?.[
    HONEYBADGER_PROJECT_KEY_ANNOTATION
  ] as string;

  const name = entity.metadata?.name;
  const aliases = entity.metadata?.annotations?.["kajabi.com/team-aliases"];
  const handles = aliases ? aliases.split(",") : [name];
  const keys = keysAnnotation
    ? keysAnnotation.split(",")
    : [DEFAULT_HONEYBADGER_PROJECT_KEY];
  const queries: { [key: string]: any } = {};

  keys.forEach((k: string) => {
    queries[k] =
      entity.metadata?.annotations?.[`honeybadger.io/query.${k}`] ||
      entity.metadata?.annotations?.[HONEYBADGER_QUERY_ANNOTATION] ||
      handles.map((h: string) => `team:${h.replace("-", "_")}_team`).join(" ");
  });

  return {
    projectKeys: keys,
    queries,
  };
};
